import { render } from "./Validations.vue?vue&type=template&id=6201a1e6&scoped=true"
import script from "./Validations.vue?vue&type=script&lang=js"
export * from "./Validations.vue?vue&type=script&lang=js"

import "./Validations.vue?vue&type=style&index=0&id=6201a1e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6201a1e6"]])

export default __exports__